// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  authRedirectUri: '/',
  authPostLogoutRedirectUri: '/',
  datexApplicationApiUrl: '/api/',
  integrationHubConfigApiUrl: '',
  integrationHubConfigurationApiScopes: [],
  legacyConnectorsConfigApiUrl: '',
  legacyConnectorsConfigApiScopes: [],
  integrationHubApiUrl: '',
  integrationHubApiScopes: [],
  integrationHubLoggingApiUrl: '',
  integrationHubLoggingApiScopes: [],
  datexAlertApiUrl: '',
  datexAlertApiScopes: [],
  datexAlertRecommndedSolutionApiUrl: '',
  datexAlertRecommndedSolutionApiScopes: [],
  kustoQueryApiUrl: '',
  kustoQueryApiScopes: [],
  footPrintAdaptorApiUrl: '',
  footPrintAdaptorApiScopes: [],
  shopifyAdaptorApiUrl: '',
  shopifyAdaptorApiScopes: [],
  wooCommerceAdaptorApiUrl: '',
  wooCommerceAdaptorApiScopes: [],
  bigCommerceAdaptorApiUrl: '',
  bigCommerceAdaptorApiScopes: [],
  mesciusLicenseKey: '*.wavelength.host,232864259645381#B14TeF5RIp4MypGOpdlYCFnUtZlMZhkRwJUd5E4Z5wUY4hTR8FDSZdmeqhTSXNXM5YGR6FWM6YzVJdTS0JUaslEbWhFb5czdt5EaFdHckRVQ5RFRH3yM73yLXhGeMpWeFZ4ZShmdIFGVrYWMDNWS6hHdVl7S7U5Z5skdqF4UxpkRxE4NChGa5o5L5U4bBpkMQlzZrR4Q9ETdZBlb8l4d0hncSF4YQlWMtJkdhlWRrYTNplWcylleRZXRwlWTWxWcQxWelh6VMhEcatEMHNDdIFFb65WUXFUOMJkYLJWQZJDOCR7QaZTVQFEUmljSnBFWiojITJCLiQTNwQUN4kjNiojIIJCLzgTO9QjMyYzM0IicfJye35XX3JiVMtkTiojIDJCLiUjVgMlS4J7bwVmUlZXa4NWQiojIOJyebpjIkJHUiwiIxATNyITMggjMwEDNyAjMiojI4J7QiwiI4N7bo9Ca4dmblxWZ6F6duoiI0IyctRkIsICelRXYEJiOiEmTDJCLiEDOzUDN6kTNyQjN8IzMyIiOiQWSiwSfdtlOicGbmJCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPRp5U7UUW4Q6QhlUMKJVaI5Ee9lDVh5kS4UXRPh7T6I4LwVXSrZDa4ZVbLZWNnV6aUxGU8gzSrVXWIhzVC56c7AzbjhjWHNTNBVDTuVmYKpFOTR5crJldUBHSXJUZSZ7QEdzUI5zNKx',
  ediLogicAppTriggerUrl: '',
  wavelengthConnectorAppGWUrl: 'https://wavelength-connector-edi-pentest.eastus2.cloudapp.azure.com/',
  ediENVPrefix: '',
  authtok: 'gJxjmNebq3g0M9XIEcXHa2PiODl8roVO',
  copilotApiUrl: '',
  copilotApiScopes: [],
  icmApiUrl: '',
  icmApiScopes: [],
  ediPublic: '',
  ediPrivate: '',
  datexDefaultAlertMessageTemplate: ''
};
